import { FC } from 'react'

import { StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  header: { fontSize: 10, marginBottom: 6, fontWeight: 'bold', height: 16 },
  field: { fontSize: 10, color: '#515164', height: 16 },
})

interface Props {
  title: string
  name?: string | null
  nif?: string | null
  address1?: string
  address2?: string | null
  phoneNumber?: string | null
  email?: string | null
}

const Column: FC<Props> = ({ title, name, nif, address1, address2, phoneNumber, email }) => (
  <View style={{ flex: 1 }}>
    <Text style={styles.header}>{title}</Text>
    {name && <Text style={styles.field}>{name}</Text>}
    {nif && <Text style={{ ...styles.field, marginBottom: 6 }}>{nif}</Text>}
    {address1 && <Text style={styles.field}>{address1}</Text>}
    {address2 && <Text style={styles.field}>{address2}</Text>}
    {phoneNumber && <Text style={styles.field}>{phoneNumber}</Text>}
    {email && <Text style={styles.field}>{email}</Text>}
  </View>
)

export default Column
